import React from "react";
import styles from "./third.module.scss";
import constants from "../../constants/home/third-section.constants";
import Card from "../../components/Cards";
import Button, { BTN_VARIANTS } from "../../components/Button";

const Third = () => {
  return (
    <div className={styles.root}>
      <span className={styles.title}>
        Sentinel <span className="blue-text">Network</span>
      </span>
      <section className={styles.cards}>
        {constants.map((c, index) => {
          return (
            <Card
              key={`home-thrid-${index}`}
              className={`${styles.card} ${styles[`card-${index}`]}`}
            >
              <img src={c.icon} alt="" />
              <span className={styles["card-title"]}>{c.title}</span>
              <span className={styles["card-description"]}>
                {c.description}
              </span>
              <section className={styles.action}>
                <Button variant={BTN_VARIANTS.primary} onClick={c.btn.onClick}>
                  <span>{c.btn.title}</span>
                </Button>
              </section>
            </Card>
          );
        })}
      </section>
    </div>
  );
};

export default Third;
